import React from 'react';
import { Route, Routes } from 'react-router-dom';
import NavBar from './components/navbar';
import About from './components/about';
import Career from './components/careers';
import SignIn from './components/signin';
import SignUp from './components/signup';
import withAuth from './components/auth';
import Chatbot from './components/chatbot';
import TermsAndConditions from './components/terms-and-conditions';
import Contribution from './components/contribution';
import Payment from './components/payment';
import { CareerProvider } from './components/career-context';
import { UserProfileProvider } from './components/user-profile-context';
import Preview from './components/preview';
import PageNotFound from './components/404';
import careerList from './components/careers.json';
import SoftwareEngineer from './components/software-engineer/software-engineer';
import FinancialAnalyst from './components/financial-analyst/financial-analyst'
import Teacher from './components/teacher/teacher';
import UIUXDesigner from './components/uiux-designer/uiux-designer';
import Architect from './components/architect/architect';
function App() {
  
  function RouteWithAuth({component: Component, isPaid }) {
    const WrappedComponent = withAuth(Component, isPaid);
    return <WrappedComponent/>;
  }

  return (
    <>
      <UserProfileProvider>
        <NavBar />
        <CareerProvider>
          <Routes>
            <Route path="/" element={<About/>}/>
            <Route path="/careers" element={<RouteWithAuth component={Career}/>} />
            <Route path="/recommended" element={<Chatbot/>}/>
            <Route path="/signin" element={<SignIn/>}/>
            <Route path="/signup" element={<SignUp/>}/>
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
            <Route path="/contribute" element={<RouteWithAuth component={Contribution}/>}/>
            <Route path="/path/:career" element={<RouteWithAuth component={Preview}/>}/>
            <Route path="/payment" element={<RouteWithAuth component={Payment}/>}/>

            {/* Career paths */}
            {/* {
              careerList.map((career) => {
                return (
                  <Route 
                    key={career.id} 
                    path={`/career/${career.id}`} 
                    element={React.lazy(()=>import(`./components/${career.id}/${career.id}`))}
                  />
                )
              })
            } */}
            <Route path={`/career/software-engineer`} element={<SoftwareEngineer/>} />
            <Route path={`/career/financial-analyst`} element={<FinancialAnalyst/>}/>
            <Route path={`/career/teacher`} element={<Teacher/>}/>
            <Route path={`/career/uiux-designer`} element={<UIUXDesigner/>}/>
            <Route path={`/career/architect`} element={<Architect/>}/>  
            {/* 404 */}
            <Route path="*" element={<PageNotFound/>}/>
          </Routes>
        </CareerProvider>
      </UserProfileProvider>
    </>
  );
}

export default App;